const body = document.querySelector('body');
const mobileNav = document.querySelector('.js-mobile-nav');
const mobileNavToggle = document.querySelectorAll('.js-mobile-nav-toggle');
const mobileNavClose = document.querySelectorAll('.js-mobile-nav-close');

const closeMobileNav = () => {
	body.classList.remove('is-mobile-open');
	mobileNav.classList.remove('is-active');
};

const openMobileNav = () => {
	body.classList.add('is-mobile-open');
	mobileNav.classList.add('is-active');
};

if (mobileNavToggle) {
	mobileNavToggle.forEach(button => {
		button.addEventListener('click', () => {
			if (mobileNav.classList.contains('is-active')) {
				closeMobileNav();
			} else {
				openMobileNav();
			}
		});
	});
}

if (mobileNavClose) {
	mobileNavClose.forEach(button => {
		button.addEventListener('click', () => {
			closeMobileNav();
		});
	});
}

const mobileNavParents = document.querySelectorAll('.mobile-nav .menu-item-has-children');

if (mobileNavParents) {
	mobileNavParents.forEach(parent => {
		parent.addEventListener('click', () => {
			parent.classList.toggle('is-active');
		});
	});
}

